import { useState } from 'react';
import { useAppDispatch } from 'store';
import { showResponse } from 'store/actions/response';

export const notifyTypeMap: Record<string, string> = {
  all: 'all_invited',
  confirmed: 'only_confirmed',
  not_confirmed: 'only_not_confirmed',
  nobody: 'nobody',
  no: 'nobody',
};

export function useNotifyModal({
  editMode,
  isEventChanged,
  updateEventWithNotify,
  sendEventReminder,
  event,
  eventLabels,
  formik,
  history,
  getEventPayload,
  setIsEventLoading,
}) {
  const dispatch = useAppDispatch();
  const [notifyModal, setNotifyModal] = useState({ open: false, type: '' });
  const [notifySelection, setNotifySelection] = useState('');
  const [pendingAction, setPendingAction] = useState<'save' | 'back' | null>(null);

  const handleNotifySelect = async (option: string) => {
    setNotifySelection(option);
    setNotifyModal({ open: false, type: '' });
    setIsEventLoading(true);
    const notifyType = notifyTypeMap[option];
    try {
      if (pendingAction === 'save') {
        if (editMode && isEventChanged()) {
          await updateEventWithNotify(notifyType, getEventPayload());
          dispatch(
            showResponse({
              title: eventLabels.eventChangedModal.eventUpdate,
              message:
                notifyType !== 'nobody'
                  ? eventLabels.eventChangedModal.notified
                  : eventLabels.eventChangedModal.noNotify,
            }),
          );
          history.goBack();
          return;
        }
        if (editMode && !isEventChanged() && notifyType !== 'nobody') {
          dispatch(
            showResponse({
              title: eventLabels.eventReminder.reminderSent,
              message: eventLabels.eventReminder.message,
            }),
          );
          sendEventReminder(event._id, notifyType).catch((err) => {
            dispatch(
              showResponse({
                title: 'Error',
                message: err?.message,
              }),
            );
          });
          history.goBack();
          return;
        }
        if (editMode && !isEventChanged() && notifyType === 'nobody') {
          history.goBack();
          return;
        }
        formik.submitForm();
        return;
      }
      if (pendingAction === 'back') {
        if (editMode && !isEventChanged() && notifyType !== 'nobody') {
          dispatch(
            showResponse({
              title: eventLabels.eventReminder.reminderSent,
              message: eventLabels.eventReminder.message,
            }),
          );
          sendEventReminder(event._id, notifyType).catch((err) => {
            dispatch(
              showResponse({
                title: 'Error',
                message: err?.message,
              }),
            );
          });
        }
        history.goBack();
        return;
      }
    } catch (err) {
      dispatch(
        showResponse({
          title: 'Error',
          message: err?.message,
        }),
      );
    } finally {
      setIsEventLoading(false);
      setPendingAction(null);
    }
  };

  return {
    notifyModal,
    setNotifyModal,
    notifySelection,
    setNotifySelection,
    pendingAction,
    setPendingAction,
    handleNotifySelect,
  };
}
